import { DataCard, DownloadReportButton } from "./DataCard";
import { renderFormattedText } from "../utils/formatText";
import type { DisplayMessage } from "../types";

export function MessageBubble({ message }: { message: DisplayMessage }) {
  const data = message.data;
  const dataList = Array.isArray(data) ? data : data ? [data] : [];

  return (
    <div className={`chat-message ${message.role}`}>
      <div className="chat-avatar">{message.role === "user" ? "🧑" : "⚡"}</div>
      <div className="chat-bubble-col">
        {/* Order: report card(s) -> LLM summary -> PDF download button(s). */}
        {message.role === "assistant" &&
          dataList.map((d, i) => (
            <div key={i}>
              <DataCard data={d} />
              {i < dataList.length - 1 && <hr className="data-divider" />}
            </div>
          ))}

        <div className="chat-bubble">{renderFormattedText(message.content)}</div>

        {message.role === "assistant" &&
          dataList.map((d, i) => <DownloadReportButton key={i} data={d} />)}
      </div>
    </div>
  );
}
